import { CurrencyRate } from "../../classes";

const CurrencyRateModule = {
  namespaced: true,
  state: {
    currencyRate: null,
    lastCurrencyRate: null,
  },
  mutations: {
    setCurrencyRate: (state, payload) => {
      state.currencyRate = payload;
    },
    setLastCurrencyRate: (state, payload) => {
      state.lastCurrencyRate = payload;
    },
  },
  actions: {
    getCurrencyRateByDate: async ({ commit }, payload) => {
      try {
        const data = await CurrencyRate.getCurrencyRateByDate(payload);
        commit("setCurrencyRate", data );
        return data;
      } catch (err) {
        console.log(err)
        throw err;
      }
    },
    getLastCurrencyRate: async ({ commit }) => {
      try {
        const data = await CurrencyRate.getLastCurrencyRate();
        commit("setLastCurrencyRate", data);
        return data;
      } catch (err) {
        console.log(err)
        throw err;
      }
    }
  },
  getters: {
    getCurrencyRate: state => { return state.currencyRate },
    getLastCurrencyRate: state => { return state.lastCurrencyRate }
  },
};
export default CurrencyRateModule;
